import { useQuery } from "@tanstack/react-query";
import { useSession } from "@/features/auth";
import { readRisk } from "@/shared/api";
import { statusOf } from "@/shared/http/errors";

export function useRisk() {
  const session = useSession();
  const query = useQuery({
    queryKey: ["risk", session.status === "signed-in" ? session.tenantId : null,
      session.status === "signed-in" ? session.accountId : null],
    enabled: session.status === "signed-in",
    retry: false,
    refetchInterval: 10_000,
    queryFn: async () => {
      const { data, error, response } = await readRisk();
      if (error !== undefined || data === undefined) {
        throw Object.assign(new Error("Risk unavailable"), { status: response?.status });
      }
      return data;
    },
  });
  if (query.fetchStatus === "paused") return { status: "unreadable" } as const;
  if (query.isError) {
    const status = statusOf(query.error);
    if (status === 403) return { status: "forbidden" } as const;
    if (status === 503) return { status: "unavailable" } as const;
    return { status: "unreadable" } as const;
  }
  if (query.isPending) return { status: "loading" } as const;
  return { status: "ready", system: query.data } as const;
}
